/**
 * Layout constants for consistent spacing across components
 */

/**
 * Standard navbar height in pixels.
 * Used for hero components that need to extend behind the sticky navbar.
 *
 * Calculation: py-4 (32px) + h-10 button height (40px) = 72px
 */
export const NAVBAR_HEIGHT = 72

/**
 * CSS classes to apply when a hero section should extend behind the navbar.
 * - `-mt-[72px]` pulls the section up behind the sticky navbar
 * - `pt-[72px]` pushes the content back down so it's visible below navbar
 *
 * Result: Background extends behind navbar, content stays in place.
 */
export const BEHIND_NAVBAR_CLASSES = '-mt-[72px] pt-[72px]'
